var map = {
	"./emerald.png": "1ee6",
	"./hacker-blog.png": "c689",
	"./leaf.png": "de61",
	"./matjek.png": "3f36",
	"./minima.png": "099e",
	"./neo-hpstr.png": "796f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0b6";